module.exports = __webpack_public_path__ + "img/singletrack-study-login.ad761656.png";